export default Alpine.data('dashboardViewGoogleMap', (tasks) => {
    return {
        tasks: tasks,
        bootMap() {
            const center = {
                lat: this.tasks[0].lat,
                lng: this.tasks[0].lng
            };

            window.initMap('map', center);

            this.tasks.forEach((task) => {
                const position = {
                    lat: task.lat,
                    lng: task.lng
                };

                this.addMarker(position, task);
            });
        },
        async addMarker(position, task) {
            const { InfoWindow } = await google.maps.importLibrary("maps");
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker")

            const infoWindow = new InfoWindow();

            const parser = new DOMParser();
            const pinSvgString = await this.pinSvgString(task.priority);
            const pinSvg = parser.parseFromString(pinSvgString, "image/svg+xml").documentElement;

            const infoMarker = new AdvancedMarkerElement({
                map: window.map,
                position: position,
                content: pinSvg,
            });

            infoMarker.addListener("gmp-click", (event) => {
                const position = infoMarker.position;

                // Demonstration of how to use the infoWindow
                infoWindow.close();
                // infoWindow.setContent(`Pin dropped at: ${position.lat}, ${position.lng}`);
                infoWindow.setContent(this.infoWindowContent(task));

                infoWindow.open(infoMarker.map, infoMarker);
            });
        },
        pinSvgString(priortyLevel) {
            const pinSvgMap = {
                'P1': '/svg/field-services/p1-pin.svg',
                'P2': '/svg/field-services/p2-pin.svg',
                'P3': '/svg/field-services/p3-pin.svg',
                'P4': '/svg/field-services/p4-pin.svg',
                'P5': '/svg/field-services/p5-pin.svg',
                'p-none': '/svg/field-services/p-none-pin.svg',
            };

            const pinSvgUrl = pinSvgMap[priortyLevel] || pinSvgMap['p-none'];

            return fetch(pinSvgUrl).then(response => response.text());
        },
        priorityColor(priority) {
            const priorityColorMap = {
                'P1': 'bg-priority1 text-white',
                'P2': 'bg-priority2',
                'P3': 'bg-priority3',
                'P4': 'bg-priority4',
                'P5': 'bg-priority5 text-white',
                'p-none': 'hidden',
            };
            return priorityColorMap[priority] || priorityColorMap['p-none'];
        },
        infoWindowContent(task) {
            const locationOutlineSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00004 1.33334C5.42004 1.33334 3.33337 3.42 3.33337 6C3.33337 9.5 8.00004 14.6667 8.00004 14.6667C8.00004 14.6667 12.6667 9.5 12.6667 6C12.6667 3.42 10.58 1.33334 8.00004 1.33334ZM4.66671 6C4.66671 4.16 6.16004 2.66667 8.00004 2.66667C9.84004 2.66667 11.3334 4.16 11.3334 6C11.3334 7.92 9.41337 10.7933 8.00004 12.5867C6.61337 10.8067 4.66671 7.9 4.66671 6Z" fill="#333333"/>
<path d="M8.00004 7.66667C8.92052 7.66667 9.66671 6.92048 9.66671 6C9.66671 5.07953 8.92052 4.33334 8.00004 4.33334C7.07957 4.33334 6.33337 5.07953 6.33337 6C6.33337 6.92048 7.07957 7.66667 8.00004 7.66667Z" fill="#333333"/>
</svg>
`;

            const personOutlineSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.99996 3.93333C8.18381 3.93333 8.36586 3.96954 8.53572 4.0399C8.70557 4.11026 8.85991 4.21338 8.98991 4.34338C9.11991 4.47338 9.22303 4.62772 9.29339 4.79757C9.36375 4.96743 9.39996 5.14948 9.39996 5.33333C9.39996 5.51718 9.36375 5.69923 9.29339 5.86909C9.22303 6.03894 9.11991 6.19328 8.98991 6.32328C8.85991 6.45328 8.70557 6.55641 8.53572 6.62676C8.36586 6.69712 8.18381 6.73333 7.99996 6.73333C7.62866 6.73333 7.27256 6.58583 7.01001 6.32328C6.74746 6.06073 6.59996 5.70463 6.59996 5.33333C6.59996 4.96203 6.74746 4.60593 7.01001 4.34338C7.27256 4.08083 7.62866 3.93333 7.99996 3.93333ZM7.99996 9.93333C9.97996 9.93333 12.0666 10.9067 12.0666 11.3333V12.0667H3.93329V11.3333C3.93329 10.9067 6.01996 9.93333 7.99996 9.93333ZM7.99996 2.66666C6.52663 2.66666 5.33329 3.86 5.33329 5.33333C5.33329 6.80666 6.52663 8 7.99996 8C9.47329 8 10.6666 6.80666 10.6666 5.33333C10.6666 3.86 9.47329 2.66666 7.99996 2.66666ZM7.99996 8.66666C6.21996 8.66666 2.66663 9.56 2.66663 11.3333V12.6667C2.66663 13.0333 2.96663 13.3333 3.33329 13.3333H12.6666C13.0333 13.3333 13.3333 13.0333 13.3333 12.6667V11.3333C13.3333 9.56 9.77996 8.66666 7.99996 8.66666Z" fill="#333333"/>
</svg>
`;

            return `<div style="">
                        <div>
                            <div
                                class="mr-1 py-1 px-2 rounded-full focus:outline-none text-xs font-bold ${this.priorityColor(task.priority)} inline-block"
                            >
                                ${task.priority}
                            </div>
                            <a class="text-md font-bold text-primary hover:text-red-700" href="">${task.title} - ${task.due_at}</a>
                        </div>
                        <div class="mt-2 flex">${locationOutlineSvg} ${task.location}</div>
                        <div class="mt-2 text-gray-700 text-xs flex">
                            ${personOutlineSvg} ${task.assigned_user ? task.assigned_user : 'Unassigned'}
                        </div>
                </div>
            `;
        },
    }
});
